module.exports = __webpack_public_path__ + "img/反馈投诉海报.png";